import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NavTitle from '../../components/nav-title'
import TextNavTitle from '../../components/TextNavTitle'
import data from '../../components/employees/organization-chart/data.json'
import CardCustom from '../../components/custom/card-custom'
import BtnBack from '../../components/btn-back'
import Expand from '../../components/employees/organization-chart/expand'
import NavRoleOrg from '../../components/nav-role-org'
import { Link } from 'react-router-dom'
import { FaAnglesRight } from 'react-icons/fa6'
export default function EmpOrganizationExpand() {
  return (
    <Row>
      <NavTitle>
        <TextNavTitle>
          <Link
            to={-1}
            className={`my-auto text-reset text-decoration-none pointer-event`}
          >
            Setting Organization <FaAnglesRight />
            <label className="small fw-medium ms-2"> Organization Expand</label>
          </Link>
        </TextNavTitle>
      </NavTitle>

      <Col xl={12}>
        <NavRoleOrg />
        <CardCustom>
          <div className="p-3">
            <Expand nodes={data} />
          </div>
        </CardCustom>
      </Col>
    </Row>
  )
}
